module.exports = __webpack_public_path__ + "5_logo_old_rovcanin_hipster_old_version.jpg?8cb8ad3793e5c22e67a0917f34e11cbf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/5_logo_old_rovcanin_hipster_old_version.jpg
// module id = 91
// module chunks = 0